// The rewritten financing FAQ answer (Prompt 2 §4.2 / §5). Kept free of imports
// so data/pricing.js and data/faqs.js can use it without a cycle through
// data/financing.js (which itself imports PRICING).
//
// `FINANCING_FAQ_ANSWER` is the plain-text version (FAQPage JSON-LD);
// `financingFaqParts(placement)` is the same sentence split into segments so
// <FaqAnswer> can render "Check your rate" as the external financing link and
// "how financing works" as an internal link to /financing.

export const FINANCING_FAQ_ANSWER =
  "Yes. We offer financing through Acorn Finance for jobs of $1,000 and up. Pre-qualifying takes a few minutes, uses a soft credit pull that doesn't affect your score, and shows you offers from multiple lenders for $1,000 to $100,000 with terms up to 20 years. You choose the offer, apply directly with that lender, and pay us the same flat-rate price you approved. Check your rate or read how financing works.";

export const financingFaqParts = (placement) => [
  { text: "Yes. We offer financing through Acorn Finance for jobs of $1,000 and up. Pre-qualifying takes a few minutes, uses a soft credit pull that doesn't affect your score, and shows you offers from multiple lenders for $1,000 to $100,000 with terms up to 20 years. You choose the offer, apply directly with that lender, and pay us the same flat-rate price you approved. " },
  { text: "Check your rate", financing: placement },
  { text: " or read " },
  { text: "how financing works", to: "/financing" },
  { text: "." },
];
